import React from "react";
import './Gracias.scss'

import { useHistory } from "react-router-dom";

import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
// import Gracias from "../../components/Cotizacion/Gracias";

const Gracias = () => {
    const history = useHistory();

    return (
        <div className="GraciasContainer">
            <section class="header-gracias">
                <Navbar />
                <div class="backNoticies"></div> 
                <div class="container-title">
                    <h3>Gracias!!</h3>
                </div>
            </section>

            <section class="body-gracias">
              <h4 id="child-modal-title">Estimado/a</h4>
              <p>
                Agradecemos su consulta y la información proporcionada.<br></br>
                Su cotización se está procesando, un ejecutivo lo contactará a la brevedad para asesorarlo/a y responder todas sus dudas.
              </p>

              <div style={{width: '100%'}}>
                <p style={{fontSize: '0.8rem'}}>
                  Puedes contactarte con nuestro Asistente Virtual vía Whatsapp
                </p>
              </div>

              {/* <button type="submit" onClick={history.push("/")} style={{width: '200px', height: '36px', fontSize: '0.9rem', background: '#D67E1B', borderRadius: '7px', color: '#ffffff'}}>
                Continuar visitando el sitio
              </button>               */}
            </section>
            <Footer />
        </div>
    );
};

export default Gracias;